import { render } from "./Youtube.vue?vue&type=template&id=8f69f7fa"
import script from "./Youtube.vue?vue&type=script&lang=js"
export * from "./Youtube.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__